var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"ma-0",attrs:{"indeterminate":_vm.value,"color":_vm.value ? 'color3' : ''}})}
var staticRenderFns = []

export { render, staticRenderFns }